import { render, staticRenderFns } from "./question-edit.vue?vue&type=template&id=287faeda&scoped=true&"
import script from "./question-edit.vue?vue&type=script&lang=js&"
export * from "./question-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287faeda",
  null
  
)

export default component.exports